import {
  ASK_VERIFICATION,
  DELETE_SPECIALIST,
  SEND_MAIL,
} from "../../../utils/keywords";
import { showDialogWithData } from "../../../redux/guest-slices/other.slice";
import { Button, Menu, Stack } from "@mui/material";
import { Link as NavLink } from "react-router-dom";
import Icons from "../../../assets/js/Icons";
import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";

function ActionMenu({ user }) {
  const [anchor, setAnchor] = useState(null);
  const dispatch = useDispatch();
  const { _id, email, fullName, isEmailVerified } = user || {};

  const handleClickMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchor(null);
  };

  const handleDelete = (id) => {
    dispatch(showDialogWithData({ type: DELETE_SPECIALIST, data: { id } }));
  };

  return (
    <Fragment>
      <Button
        size="small"
        variant="contained"
        sx={{
          lineHeight: "1",
          borderRadius: "20px",
          ".MuiButton-endIcon": { ml: "4px" },
        }}
        endIcon={<Icons.ArrowDownSharp />}
        onClick={handleClickMenu}
      >
        Action
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          mt: 0.5,
          ".MuiList-root": { py: 0.5 },
          ".MuiPaper-root": { boxShadow: "0 0 15px 0 #00000040" },
        }}
        component="div"
        onClose={handleCloseMenu}
        slotProps={{ list: { component: "div" } }}
      >
        <Stack sx={{ minWidth: 120, ".MuiButton-root": { px: 1.5 } }}>
          <Button
            size="small"
            sx={{ justifyContent: "start" }}
            startIcon={<Icons.UserQuestionStrokeStandard />}
            onClick={() => {
              dispatch(
                showDialogWithData({
                  type: ASK_VERIFICATION,
                  data: { email, username: fullName, isEmailVerified },
                })
              );
              handleCloseMenu();
            }}
          >
            Ask for verification
          </Button>

          <Button
            size="small"
            LinkComponent={NavLink}
            sx={{ justifyContent: "start" }}
            to={`/specialist/detail/${_id}`}
            startIcon={<Icons.StudentCardStroke />}
          >
            Details
          </Button>
          <Button
            size="small"
            sx={{ justifyContent: "start" }}
            startIcon={<Icons.MailStrokeStandard />}
            onClick={() => {
              dispatch(
                showDialogWithData({
                  type: SEND_MAIL,
                  data: { email, username: fullName },
                })
              );
              handleCloseMenu();
            }}
          >
            Send mail
          </Button>
          <Button
            size="small"
            sx={{ justifyContent: "start" }}
            startIcon={<Icons.EditStroke />}
          >
            Edit
          </Button>
          <Button
            size="small"
            sx={{ justifyContent: "start" }}
            startIcon={<Icons.DeleteStroke />}
            onClick={() => {
              handleDelete(_id);
            }}
          >
            Delete
          </Button>
        </Stack>
      </Menu>
    </Fragment>
  );
}

export default ActionMenu;
